module.exports = {"511971007":"兴文街道","511971008":"奇章街道","511971009":"时新街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511971.json
// module id = 2393
// module chunks = 0